import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getAssetGroupListSaga = createAction(
  "GET_ASSET_GROUP",
  ({ payload, params }: SagaActionParams<Type.AssetGroupDto[]>) => ({
    payload,
    url: "/api/admin/assetgroups" + (params ? params : ""),
  })
);
export const getAssetGroupDetailsSaga = createAction(
  "GET_ASSET_GROUP_DETAILS",
  ({ payload, id }: SagaActionParams<Type.AssetGroupDetailDto>) => ({
    payload,
    url: "/api/admin/assetgroups/" + id,
  })
);
export const createAssetGroupSaga = createAction(
  "CREATE_ASSET_GROUP",
  ({ payload, body }: SagaActionParams<Type.AssetGroupDto>) => ({
    payload,
    url: "/api/admin/assetgroups",
    body,
  })
);
export const updateAssetGroupSaga = createAction(
  "UPDATE_ASSET_GROUP",
  ({ payload, id, body }: SagaActionParams<Type.AssetGroupDto>) => ({
    payload,
    url: "/api/admin/assetgroups/" + id,
    body,
  })
);
export const deleteAssetGroupSaga = createAction(
  "DELETE_ASSET_GROUP",
  ({ payload, id }: SagaActionParams<Type.AssetGroupDto>) => ({
    payload,
    url: "/api/admin/assetgroups/" + id,
  })
);

const assetgroupsSaga = [
  takeLatest<any>(
    getAssetGroupListSaga.toString(),
    (payload: SagaGenericParams<Type.AssetGroupDto[]>) =>
      getSaga<Type.AssetGroupDto[]>(payload)
  ),
  takeLatest<any>(
    getAssetGroupDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.AssetGroupDetailDto>) =>
      getSaga<Type.AssetGroupDetailDto>(payload)
  ),
  takeLatest<any>(
    createAssetGroupSaga.toString(),
    (payload: SagaGenericParams<Type.AssetGroupDto>) =>
      postSaga<Type.AssetGroupDto>(payload)
  ),
  takeLatest<any>(
    updateAssetGroupSaga.toString(),
    (payload: SagaGenericParams<Type.AssetGroupDto>) =>
      putSaga<Type.AssetGroupDto>(payload)
  ),
  takeLatest<any>(
    deleteAssetGroupSaga.toString(),
    (payload: SagaGenericParams<any>) => deleteSaga<Type.AssetGroupDto>(payload)
  ),
];

export default assetgroupsSaga;
